import { WithEnterpriseId, WithServiceId } from '@mews-commander/types';
import { Stack, Typography } from '@optimus-web/core';
import { LocalizedProperty, lt } from '@mews/framework';
import { useViewTypeName } from '../hooks';
import { FilterFormValues } from '../schemas';

interface Props extends WithEnterpriseId, WithServiceId {
    view: FilterFormValues['view'];
}

export const SellLimitsTitle = ({ view, serviceId, enterpriseId }: Props) => {
    const { name: viewTypeName, names: viewTypeNames } = useViewTypeName({
        view,
        enterpriseId,
        serviceId,
    });

    return (
        <Stack spacing="100">
            <Typography textStyle="titleLargeStrong" as="div">
                {viewTypeNames ? <LocalizedProperty property={viewTypeNames} /> : viewTypeName}
            </Typography>
            <Typography textStyle="titleLarge" variant="secondary" as="div">
                {view.type === 'rate' ? lt('Rate') : lt('RateGroup')}
            </Typography>
        </Stack>
    );
};
